import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Phone, Mail, Globe } from "lucide-react";

const quickLinks = ["Support", "Raise Ticket", "Documentation"];
const companyLinks = [
  "About Us",
  "Our Products",
  "Customer Stories",
  "Careers",
];
const socialLinks = [
  { icon: "fab fa-facebook-f", link: "https://www.facebook.com/Perecoindia/" },
  {
    icon: "fab fa-linkedin-in",
    link: "https://in.linkedin.com/company/pereco-india",
  },
  { icon: "fab fa-youtube", link: "https://www.youtube.com/@perecoindia" },
  { icon: "fab fa-instagram", link: "https://www.instagram.com/pereco_india" },
];
import footerLogo1 from "./full logo- white.avif";
export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#D03110" }} className="text-white-50">
      <Container fluid="xl" className="py-5">
        <Row className="g-4">
          <Col xs={12} md={3}>
            <img
              src={footerLogo1}
              alt="footer logo"
              className="img-fluid mb-4"
              style={{ maxWidth: "260px" }}
            />
            <div>© 2026 Perennial Code IT. All rights reserved.</div>
            <div className="d-flex gap-3">
              <a
                href="https://perennialcode.in/PrivacyPolicy"
                className="text-white-50"
              >
                Privacy Policy
              </a>
              <a
                href="https://perennialcode.in/Terms&Conditions"
                className="text-white-50"
              >
                Terms of Service
              </a>
            </div>
          </Col>

          <Col xs={6} md={2}>
            <p
              className="text-white small fw-bold mb-3"
              style={{ letterSpacing: "0.05em" }}
            >
              QUICK LINKS
            </p>
            <ul className="list-unstyled d-flex flex-column gap-2 small mb-0">
              {quickLinks.map((l) => (
                <li key={l}>
                  <a href="#" className="text-white-50">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </Col>

          <Col xs={6} md={2}>
            <p
              className="text-white small fw-bold mb-3"
              style={{ letterSpacing: "0.05em" }}
            >
              COMPANY
            </p>
            <ul className="list-unstyled d-flex flex-column gap-2 small mb-0">
              {companyLinks.map((l) => (
                <li key={l}>
                  <a href="#" className="text-white-50">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </Col>

          <Col xs={12} md={3}>
            <p
              className="text-white small fw-bold mb-3"
              style={{ letterSpacing: "0.05em" }}
            >
              CONNECT WITH US
            </p>
            <ul className="list-unstyled d-flex flex-column gap-2 small mb-0">
              <li className="d-flex align-items-center gap-2">
                <Phone size={14} /> +91 40 2988 1024
              </li>
              <li className="d-flex align-items-center gap-2">
                <Mail size={14} /> support@perennialcode.com
              </li>
              <li className="d-flex align-items-center gap-2">
                <Globe size={14} /> www.perennialcode.com
              </li>
            </ul>
            <div className="d-flex gap-2 mt-3">
              {/* {[Linkedin, Facebook, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="d-inline-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 30, height: 30, backgroundColor: 'rgba(255,255,255,.1)', color: '#fff' }}>
                  <Icon size={14} />
                </a>
              ))} */}
            </div>
          </Col>

          {/* <Col xs={12} md={2}>
            <div className="bg-white rounded-3 p-3 d-flex align-items-center gap-2">
              <Handshake size={22} className="text-brand-blue flex-shrink-0" />
              <div>
                <p className="fw-bold text-dark mb-0" style={{ fontSize: 15 }}>{summary?.businesses || '550+'}</p>
                <p className="text-muted mb-0" style={{ fontSize: 10.5 }}>{summary?.label || 'Businesses Trust Our Solutions'}</p>
              </div>
            </div>
          </Col> */}
          <Col xs={6} md={2}>
            <p
              className="text-white small fw-bold mb-3"
              style={{ letterSpacing: "0.05em" }}
            >
              FOLLOW US
            </p>
            <div className="d-flex gap-2">
              {socialLinks.map((item, i) => (
                <a
                  key={i}
                  href={item.link}
                  className="d-inline-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: 32,
                    height: 32,
                    backgroundColor: "rgba(255,255,255,.1)",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <div className="d-none" style={{ backgroundColor: "#9F1717" }}>
        <Container
          fluid="xl"
          className="py-3 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 small"
        >
          <span>© 2026 Perennial Code IT. All rights reserved.</span>
          <div className="d-flex gap-3">
            <a href="#" className="text-white-50">
              Privacy Policy
            </a>
            <a href="#" className="text-white-50">
              Terms of Service
            </a>
          </div>
        </Container>
      </div>
    </footer>
  );
}
